var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finish_loading),expression:"finish_loading"}],class:_vm.show ? 'overlay overlay-anim-open' : 'overlay overlay-anim-close',attrs:{"id":"uni-loading"}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }